import { makeStyles } from 'tss-react/mui';

export enum ResponsiveTypeVariant {
  h1 = 'h1',
  h2 = 'h2',
  h3 = 'h3',
  h4 = 'h4',
  h4Hyperlink = 'h4Hyperlink',
  h5 = 'h5',
  body2 = 'body2',
  body = 'body',
  caption = 'caption',
  eyebrow = 'eyebrow',
  quote = 'quote',
  captionHyperlink = 'captionHyperlink',
}

interface Props {
  fixed?: boolean;
}

const useGlobalStyles = makeStyles<Props>({ name: 'Global' })(
  ({ breakpoints, type }, { fixed }) => ({
    h1: {
      ...type['40_medium'],
      textWrap: 'pretty',
      [breakpoints.up('sm')]: { ...type['56_medium'] },
      [breakpoints.up('lg')]: { ...type['64_medium'] },
    },
    h2: {
      ...type['32_medium'],
      textWrap: 'pretty',
      [breakpoints.up('sm')]: { ...type['40_medium'] },
      [breakpoints.up('lg')]: { ...type['56_medium'] },
      [breakpoints.up('xl')]: {
        fontSize: fixed
          ? type['56_medium'].fontSize
          : type['64_medium'].fontSize,
        lineHeight: fixed
          ? type['56_medium'].lineHeight
          : type['64_medium'].lineHeight,
        letterSpacing: fixed
          ? type['56_medium'].letterSpacing
          : type['64_medium'].letterSpacing,
      },
    },
    h3: {
      ...type['24_medium'],
      [breakpoints.up('sm')]: { ...type['28_medium'] },
      [breakpoints.up('lg')]: { ...type['32_medium'] },
      [breakpoints.up('xl')]: {
        fontSize: fixed
          ? type['32_medium'].fontSize
          : type['40_medium'].fontSize,
        lineHeight: fixed
          ? type['32_medium'].lineHeight
          : type['40_medium'].lineHeight,
        letterSpacing: fixed
          ? type['32_medium'].letterSpacing
          : type['40_medium'].letterSpacing,
      },
    },
    h4: {
      ...type['18_medium'],
      [breakpoints.up('sm')]: { ...type['20_medium'] },
      [breakpoints.up('lg')]: { ...type['24_medium'] },
      [breakpoints.up('xl')]: {
        fontSize: fixed
          ? type['24_medium'].fontSize
          : type['28_medium'].fontSize,
        lineHeight: fixed
          ? type['24_medium'].lineHeight
          : type['28_medium'].lineHeight,
        letterSpacing: fixed
          ? type['24_medium'].letterSpacing
          : type['28_medium'].letterSpacing,
      },
    },
    h4Hyperlink: {
      ...type['18_medium-hyperlink'],
      [breakpoints.up('sm')]: { ...type['20_medium-hyperlink'] },
      [breakpoints.up('lg')]: { ...type['24_medium-hyperlink'] },
      [breakpoints.up('xl')]: {
        fontSize: fixed
          ? type['24_medium-hyperlink'].fontSize
          : type['28_medium-hyperlink'].fontSize,
        lineHeight: fixed
          ? type['24_medium-hyperlink'].lineHeight
          : type['28_medium-hyperlink'].lineHeight,
        letterSpacing: fixed
          ? type['24_medium-hyperlink'].letterSpacing
          : type['28_medium-hyperlink'].letterSpacing,
      },
    },
    h5: {
      ...type['16_medium'],
      [breakpoints.up('sm')]: { ...type['18_medium'] },
      [breakpoints.up('lg')]: { ...type['20_medium'] },
      [breakpoints.up('xl')]: {
        fontSize: fixed
          ? type['20_medium'].fontSize
          : type['24_medium'].fontSize,
        lineHeight: fixed
          ? type['20_medium'].lineHeight
          : type['24_medium'].lineHeight,
        letterSpacing: fixed
          ? type['20_medium'].letterSpacing
          : type['24_medium'].letterSpacing,
      },
    },
    bodyHyperlink: {
      ...type['14_medium-hyperlink'],
      [breakpoints.up('sm')]: { ...type['16_medium-hyperlink'] },
      [breakpoints.up('lg')]: { ...type['20_medium-hyperlink'] },
      [breakpoints.up('xl')]: {
        fontSize: fixed
          ? type['20_medium-hyperlink'].fontSize
          : type['24_medium-hyperlink'].fontSize,
        lineHeight: fixed
          ? type['20_medium-hyperlink'].lineHeight
          : type['24_medium-hyperlink'].lineHeight,
        letterSpacing: fixed
          ? type['20_medium-hyperlink'].letterSpacing
          : type['24_medium-hyperlink'].letterSpacing,
      },
    },
    body2: {
      ...type['18_regular'],
      [breakpoints.up('sm')]: { ...type['20_regular'] },
      [breakpoints.up('lg')]: { ...type['24_regular'] },
    },
    body: {
      ...type['14_regular'],
      [breakpoints.up('sm')]: { ...type['16_regular'] },
      [breakpoints.up('lg')]: { ...type['18_regular'] },
    },
    caption: {
      ...type['12_regular'],
      [breakpoints.up('sm')]: { ...type['14_regular'] },
      [breakpoints.up('lg')]: { ...type['16_regular'] },
    },
    eyebrow: {
      textTransform: 'uppercase',
      ...type['12_semibold'],
    },
    quote: {
      ...type['24_regular'],
      [breakpoints.up('sm')]: { ...type['40_regular'] },
      [breakpoints.up('lg')]: { ...type['44_regular'] },
    },
    chip: {
      ...type['12_chip'],
    },
    captionHyperlink: {
      ...type['12_medium-hyperlink'],
      [breakpoints.up('sm')]: {
        ...type['14_medium-hyperlink'],
      },
      [breakpoints.up('lg')]: {
        ...type['16_medium-hyperlink'],
      },
    },
  })
);

export default useGlobalStyles;
